import { authorizedRequest } from "./apiHelper";

export const getContactSettingAsInt = (configItemId, defaultValue = null) => {
  const setting = getContactSetting(configItemId);
  if (setting) {
    return parseInt(setting);
  }

  return defaultValue;
};

export const getContactSetting = (configItemId, defaultValue = null) => {
  const contactSetting = getAllContactSettings().find(x => x.configItemId === configItemId);

  return contactSetting ? contactSetting.setting : defaultValue;
};

export const getAllContactSettings = () => {
  const contactSettingsString = localStorage.getItem("contactSettings");
  if (!contactSettingsString) {
    localStorage.setItem("contactSettings", []);

    return [];
  }

  return JSON.parse(contactSettingsString);
};

export const setContactSetting = (configItemId, setting, persist = true) => {
  if (persist) {
    authorizedRequest("/contactSettings", "POST", { configItemId, setting });
  }

  const contactSettings = getAllContactSettings();
  let contactSetting = contactSettings.find(x => x.configItemId === configItemId);
  if (!contactSetting) {
    contactSetting = { configItemId };
    contactSettings.push(contactSetting);
  }
  contactSetting.setting = setting;
  localStorage.setItem("contactSettings", JSON.stringify(contactSettings));
};
